import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchOutsourceLab } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { ActionTypes } from "../../../redux/type";

const OutsourceLabDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
}) => {
  const dispatch = useDispatch();
  const labName = getValues().lab_name;
  const selectedOutsourceLab = watch("outsource_lab_id");

  const { data, isLoading, error } = useQuery(
    ["OutsourceLab"],
    () => fetchOutsourceLab(),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Lab Department</div>;

  const modifiedData = data?.data?.data?.map((ele) => ({
    ...ele,
    outsource_lab_id: ele.id,
  }));

  const options =
    modifiedData?.map((lab) => ({
      value: lab.outsource_lab_id,
      label: lab.lab_name,
    })) || [];

  const selectedOption = options.find(
    (option) => option.value === selectedOutsourceLab
  );
  return (
    <Controller
      name="outsource_lab"
      control={control}
      rules={{ required: "Outsource Lab Name is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Lab Name"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("outsource_lab_id", value);
          }}
          className={`react-select-container ${
            errors.outsource_lab_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default OutsourceLabDropdown;
